import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import bootstrap, { getAppTheme } from './bootstrap';
import { URL } from 'url-polyfill/url';

import './index.css';

const renderApp = (instanceUrl, returnUrl, { login, favicon, title }, facebookAppId, googleAppId, isCordova = false, termsShort, termsLong, captchaKey) => {
  const root = document.getElementById('root');
  root.style.backgroundColor = login.backgroundColor;
  if (login.backgroundImage) {
      root.style.backgroundImage = login.backgroundImage;
  } else if (login.background) {
      root.style.background = login.background;
}

  return ReactDOM.render( < App favicon={favicon} title={title} appTheme={login} instanceUrl={instanceUrl} returnUrl={returnUrl} facebookAppId={facebookAppId} googleAppId={googleAppId} isCordova={isCordova} termsShort={termsShort} termsLong={termsLong} captchaKey={captchaKey}/> , root);
}

bootstrap()
  // .then(renderApp, renderApp)
  .then(({ cas, data }) => {
    const url = new URL(window.location.href);
    let state = cas.defaultState;
    try {
        state = Object.assign(state, JSON.parse(atob(url.searchParams.get('state'))));
        console.log(state);
    } catch (error) {
        console.log('Failed to read state, using defaults');
    }
    // the user has an active session so no need to show the login page
    // try to redirect to previous app or framework if no app found
    if (!data.token) {
      renderApp(`${url.protocol}//${data.urls.instance}`, state.continue, getAppTheme(data.guiSettings), data.facebookEnabled && data.facebookAppId, data.googleEnabled && data.googleAppId, state.isCordova, data.termsAndConditionsShort, data.termsAndConditionsLong, data.captchaKey, data.instance);
    } else {
      window.location.href = state.continue;
    }
  }, (error) => {
    // the iframe doesn't work - something's wrong :(
    console.log(error);
    // renderApp();
  });



// WEBPACK FOOTER //
// ./src/index.js